import { useCallback } from "react"

import { transport, useTransportQueryUtils } from "@/transport"

/** Refresh existing Coval directory readers after a Clerk membership change. */
export function useInvalidateOrganizationUsers() {
  const utils = useTransportQueryUtils()
  return useCallback(
    () => utils.invalidateOperation(transport.operations.getOrganizationUsers),
    [utils],
  )
}
